import { Model as i } from "../../../../model.js";
class s extends i {
  constructor(r) {
    super(), this.type = r.type, this.brand = r.brand, this.expiryMonth = r.expiryMonth, this.expiryYear = r.expiryYear, this.holderName = r.holderName, this.id = r.id, this.lastFour = r.lastFour, this.name = r.name, this.networkTxReference = r.networkTxReference, this.supportedRecurringProcessingModels = r.supportedRecurringProcessingModels, this.supportedShopperInteractions = r.supportedShopperInteractions, this.preferred = r.preferred;
  }
}
export {
  s as AdyenStoredPaymentMethodModel
};
//# sourceMappingURL=adyenStoredPaymentMethod.model.js.map
